// extracted by mini-css-extract-plugin
export default {"details-container":"style_details-container__6K-In","detail":"style_detail__028Qr","label":"style_label__bq0jn","value":"style_value__KqxZG"};